import { Routes } from '@angular/router';
import { PrensaComponent } from './prensa/prensa.component';
import { AutorxsComponent } from './autorxs/autorxs.component';
import { NosotrxsComponent } from './nosotrxs/nosotrxs.component';
import { ContactoComponent } from './contacto/contacto.component';
import { AutorxsParticularesComponent } from './autorxs-particulares/autorxs-particulares.component';
import { LibreriasComponent } from './librerias/librerias.component';
import { SuccessComponent } from './success/success.component';
import { FailureComponent } from './failure/failure.component';
import { PendingComponent } from './pending/pending.component';
import { ExtrasComponent } from './extras/extras.component';
import { AdminComponent } from './admin/admin.component';
import { authGuard } from './auth.guard';
import { LoginComponent } from './login/login.component';
import { ToolsComponent } from './admin/tools/tools.component';
import { FilesComponent } from './admin/files/files.component';
import { LibreriasAdminComponent } from './admin/librerias/librerias.component';
import { BooksComponent } from './admin/books/books.component';

export const routes: Routes = [
    {
        path: 'catalogo',
        loadComponent: () => import('./catalogo/catalogo.component').then(m => m.CatalogoComponent)
    },
    {
        path: 'catalogo/:id',
        loadComponent: () => import('./catalogo-particular/catalogo-particular.component').then(m => m.CatalogoParticularComponent)
    },
    {
        path: 'carrito',
        loadComponent: () => import('./carrito/carrito.component').then(m => m.CarritoComponent)
    },
    { path: 'prensa', component: PrensaComponent },
    { path: 'autorxs', component: AutorxsComponent },
    { path: 'autorxs/:id', component: AutorxsParticularesComponent },
    { path: 'nosotrxs', component: NosotrxsComponent },
    { path: 'librerias', component: LibreriasComponent },
    { path: 'contacto', component: ContactoComponent },
    { path: 'success', component: SuccessComponent },
    { path: 'failure', component: FailureComponent },
    { path: 'prending', component: PendingComponent },
    { path: 'extras', component: ExtrasComponent },
    { path: 'login', component: LoginComponent },
    { path: 'admin/dashboard', component: AdminComponent, canActivate: [authGuard] },
    {
        path: 'admin/orders',
        loadComponent: () => import('./admin/orders/orders.component').then(m => m.OrdersComponent),
        canActivate: [authGuard]
    },
    {
        path: 'admin/comments',
        loadComponent: () => import('./admin/comments/comments.component').then(m => m.CommentsComponent),
        canActivate: [authGuard]
    },
    { path: 'admin/tools', component: ToolsComponent, canActivate: [authGuard] },
    { path: 'admin/books', component: BooksComponent, canActivate: [authGuard] },
    { path: 'admin/bookstores', component: LibreriasAdminComponent, canActivate: [authGuard] },
    { path: 'admin/files', component: FilesComponent, canActivate: [authGuard] },
    { path: 'admin', redirectTo: 'admin/dashboard', pathMatch: 'full' },
    { path: '', redirectTo: 'catalogo', pathMatch: 'full' }
];
